module.exports = __webpack_public_path__ + "static/img/about.868056c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about.png
// module id = bbtd
// module chunks = 1